"use client";

import { ShareButton } from "./share-button";
import { useShareData } from "./share-data-context";

export function ShareButtonWithContext() {
  const { shareData } = useShareData();

  return <ShareButton shareData={shareData} />;
}
